import $axios from '@/api/apiPublic';

const getArticles = async category => {
  const response = await $axios.get(
    `articles/partner-article?category=${category}`,
  );
  return response;
};

const getArticle = async id => {
  const response = await $axios.get(`articles/partner-article/${id}`);
  return response;
};

export default {
  getArticles,
  getArticle,
};
